// Single source of truth for blog config used by Blog + Admin pages.
export const BLOG_PATH = "/emerald-coast-real-estate-blog";

export const BLOG_CATEGORIES = [
  "Market Updates",
  "Buying Tips",
  "Selling Tips",
  "Mortgage & Refinancing",
  "Living in Florida",
  "City Spotlight",
  "Local Gems & Hidden Spots",
  "Insurance in Florida",
  "Tax & Homestead",
  "Investing & 1031",
];
